import { PRODUCT_LINE_CODE } from '../../../shared/constants/product-lines-codes';
import { cementBag } from './cement-bag';
import { cementBulk } from './bulk';

export const usConfig = {
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
  [PRODUCT_LINE_CODE.BULK_CEMENT]: cementBulk,
};
